export default "__VITE_ASSET__a7180052__"